import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createBrowserHistory } from "history";
import "./App.scss";
import "./styles/activeDocuments.css";
import "./styles/templateEditor.css";
import "./styles/audit.css";
import LoginView from "./Views/Login";
import AppRoot from "./Views/Root";
import { LoginViaTd6Token, Logout } from "./actions/LoginActions";
import { GetAppSettings } from "./actions/AppActions";
import { RaiseHotKeyEvent } from "./actions/HotKeyActions";
import { GetSystemSettings } from "./actions/SystemSettingsActions";
const App = () => {
  const dispatch = useDispatch();
  const loginInfo = useSelector((state) => state.loginInfo.value);
  const systemSettingsInfo = useSelector((state) => state.systemSettingsInfo.value);
  const [userLoggedIn, updateUserLoggedIn] = useState(false);
  const customHistory = createBrowserHistory();
  useEffect(() => {
    let token = getCookie("td6Token");
    if (token === null) {
      token = window.localStorage.getItem("td6Token");
    }
    var url = window.location;
    if (url.pathname.includes("TrinFormsLogin")) {
      if (loginInfo.loggedIn) {
        customHistory.push(`/ActiveDocuments`);
        location.reload();
      } else {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        token = urlParams.get("token");
      }
    }
    if (url.pathname.includes("TrinFormsDirectLink")) {
      const pathSegments = window.location.pathname.split("/");
      const id = pathSegments[pathSegments.length - 1];
      const token2 = new URLSearchParams(window.location.search).get("token");
      console.log("ID:", id);
      console.log("Token:", token2);
      if (loginInfo.loggedIn) {
        customHistory.push(`/Document/` + id);
        location.reload();
      } else {
        token = token2;
        customHistory.push(`/Document/` + id);
        location.reload();
      }
    }
    if (systemSettingsInfo.loaded) {
      let trinFormsUrl = systemSettingsInfo.trinFormsUrl;
      if (trinFormsUrl) {
        const fullHost = window.location.hostname;
        const parts = fullHost.split(".");
        const baseDomain = parts.slice(-2).join(".");
      }
    } else {
      GetSystemSettings(dispatch);
      GetAppSettings(dispatch);
    }
    if (loginInfo.loggedIn === false && userLoggedIn === false) {
      if (token) {
        LoginViaTd6Token(token, dispatch);
      } else {
        if (loginInfo.loggedIn === false) {
          console.log("loggedOut");
        }
      }
    }
    if (loginInfo.loggedIn === false && userLoggedIn === true) {
      updateUserLoggedIn(false);
      if (loginInfo.expiredToken === true) {
        localStorage.setItem("td6Token", "");
      } else {
        let token2 = window.localStorage.getItem("td6Token");
        if (token2) {
          console.log("logInViaToken");
          LoginViaTd6Token(token2, dispatch);
        }
      }
    } else if (loginInfo.loggedIn === true && userLoggedIn === false) {
      updateUserLoggedIn(true);
      localStorage.setItem("td6Token", loginInfo.jwtToken);
      document.addEventListener("keyup", onKeyPress, true);
      GetAppSettings(dispatch);
    }
    return () => {
      document.removeEventListener("keyup", onKeyPress);
    };
  }, [loginInfo, systemSettingsInfo]);
  function getCookie(name) {
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      const [key, value] = cookie.trim().split("=");
      if (key === name) {
        return decodeURIComponent(value);
      }
    }
    return null;
  }
  const onKeyPress = (e) => {
    if (e.key === "F2") {
      RaiseHotKeyEvent("F2");
    }
    if (e.key === "F4") {
      RaiseHotKeyEvent("F4");
    }
    if (e.key === "F8") {
      RaiseHotKeyEvent("F8");
    }
  };
  return /* @__PURE__ */ React.createElement("div", { className: "App Light" }, /* @__PURE__ */ React.createElement(Router, null, userLoggedIn && /* @__PURE__ */ React.createElement(Routes, null, /* @__PURE__ */ React.createElement(Route, { path: "*", element: /* @__PURE__ */ React.createElement(AppRoot, null) })), !userLoggedIn && /* @__PURE__ */ React.createElement(Routes, null, /* @__PURE__ */ React.createElement(Route, { path: "*", element: /* @__PURE__ */ React.createElement(LoginView, null) }))));
};
export default App;
